const initialState = {
  logData: {
    logList: [],
    isLoading: false,
  },
};

export default initialState;
